import MondayButton from "../../../commonComponents/MondayButton/MondayButton";
import { Tick } from "../../assets/index";
import { CloseOutlined } from "@ant-design/icons";
import "./FormActionButtons.scss";

const FormActionButtons = ({
  className = "",
  onSubmit,
  discardButtonText = "Hidhni",
  submitButtonText = "Paraqisni",
  onDiscard,
}) => (
  <div className={`docFormActionButtons ${className}`.trim()}>
    <MondayButton
      className="mondayButtonRed"
      onClick={onDiscard}
      Icon={<CloseOutlined />}
    >
      {discardButtonText}
    </MondayButton>
    <MondayButton
      className="mondayButtonGreen"
      onClick={onSubmit}
      Icon={<Tick className="submitIcon" />}
    >
      {submitButtonText}
    </MondayButton>
  </div>
);

export default FormActionButtons;
